var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCheckoutAddress = function SvgIconCheckoutAddress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.64,
    height: 40.55,
    viewBox: "0 0 26.64 20.550",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1229",
    "data-name": "Group 1229",
    transform: "translate(-540 -532.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1204",
    "data-name": "Group 1204",
    transform: "translate(370.31 300.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    "data-name": "Group 1203",
    transform: "translate(169.69 228.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M183.01,228.04a13.322,13.322,0,0,0-13.32,13.32,12.93,12.93,0,0,0,.124,1.723c.037.3.084.6.137.9.007.042.015.082.024.124,1.854,10.112,13.034,19.454,13.034,19.454s11.18-9.342,13.034-19.454c.009-.042.018-.082.024-.122.053-.3.1-.6.137-.9a12.978,12.978,0,0,0,.124-1.725,13.322,13.322,0,0,0-13.32-13.32Zm0,19.98a6.66,6.66,0,1,1,6.66-6.66,6.66,6.66,0,0,1-6.66,6.66Z",
    transform: "translate(-169.69 -228.04)",
    fill: "#173a6d"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCheckoutAddress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_checkout_address.1e519c25.svg";
export { ForwardRef as ReactComponent };